export default [
  {
    id: 'N/A',
    name: 'Select your company',
  },
  {
    id: 'alaska',
    name: 'Alaska Airlines Mileage Plan™',
  },
  {
    id: 'ally',
    name: 'Ally',
  },
  {
    id: 'alterra',
    name: 'Alterra',
  },
  {
    id: 'amazon',
    name: 'Amazon',
  },
  {
    id: 'amex',
    name: 'American Express',
  },
  {
    id: 'ascent',
    name: 'Ascent',
  },
  {
    id: 'axos',
    name: 'Axos',
  },
  {
    id: 'bbva',
    name: 'BBVA',
  },
  {
    id: 'better',
    name: 'Better.com',
  },
  {
    id: 'betterment',
    name: 'Betterment',
  },
  {
    id: 'capitalone',
    name: 'Capital One',
  },
  {
    id: 'charlesschwab',
    name: 'Charles Schwab',
  },
  {
    id: 'chase',
    name: 'JPMorgan Chase',
  },
  {
    id: 'chime',
    name: 'Chime',
  },
  {
    id: 'citi',
    name: 'Citibank',
  },
  {
    id: 'collegeave',
    name: 'College Ave',
  },
  {
    id: 'commonbond',
    name: 'CommonBond',
  },
  {
    id: 'connexus',
    name: 'Connexus Credit Union',
  },
  {
    id: 'delta',
    name: 'Delta SkyMiles',
  },
  {
    id: 'discover',
    name: 'Discover',
  },
  {
    id: 'earnest',
    name: 'Earnest',
  },
  {
    id: 'ellevest',
    name: 'Ellevest',
  },
  {
    id: 'fidelity',
    name: 'Fidelity',
  },
  {
    id: 'flagstar',
    name: 'Flagstar Bank',
  },
  {
    id: 'fundrise',
    name: 'Fundrise',
  },
  {
    id: 'geico',
    name: 'GEICO',
  },
  {
    id: 'guaranteedrate',
    name: 'Guaranteed Rate',
  },
  {
    id: 'hrblock',
    name: 'H&R Block Free',
  },
  {
    id: 'ihg',
    name: 'IHG Rewards Club',
  },
  {
    id: 'lightstream',
    name: 'LightStream',
  },
  {
    id: 'marcus',
    name: 'Marcus',
  },
  {
    id: 'nasb',
    name: 'North American Savings Bank',
  },
  {
    id: 'navyfederal',
    name: 'Navy Federal',
  },
  {
    id: 'onefinance',
    name: 'One Finance',
  },
  {
    id: 'penfedpowered',
    name: 'PenFed',
  },
  {
    id: 'primelending',
    name: 'Prime Lending',
  },
  {
    id: 'radius',
    name: 'Radius Bank',
  },
  {
    id: 'sofi',
    name: 'SoFi',
  },
  {
    id: 'tdameritrade',
    name: 'TD Ameritrade',
  },
  {
    id: 'turbotax',
    name: 'TurboTax',
  },
  {
    id: 'upgrade',
    name: 'Upgrade',
  },
  {
    id: 'upstart',
    name: 'Upstart',
  },
  {
    id: 'usbank',
    name: 'U.S. Bank',
  },
  {
    id: 'vanguard',
    name: 'Vanguard Digital Advisor',
  },
  {
    id: 'wellsfargo',
    name: 'Wells Fargo',
  },
  {
    id: 'vanguard',
    name: 'Vanguard Digital Advisor',
  },
  {
    id: 'worldnomads',
    name: 'World Nomads',
  },
  {
    id: 'worldofhyatt',
    name: 'World of Hyatt',
  },
];
